/** Translation-key pairs for each RD3C scoring dimension label, ordered to match
 *  `DIMENSION_CONFIG` in `~/utils/quality-score-transforms.ts` (relevance,
 *  differentiation, completeness, compliance, correctness). */
export const RD3C_DIMENSION_LABEL_KEYS: { titleKey: string; descriptionKey: string }[] = [
  {
    titleKey: 'qualityScore.rd3c.correctnessTitle',
    descriptionKey: 'qualityScore.rd3c.correctnessDescription',
  },
  {
    titleKey: 'qualityScore.rd3c.completenessTitle',
    descriptionKey: 'qualityScore.rd3c.completenessDescription',
  },
  {
    titleKey: 'qualityScore.rd3c.complianceTitle',
    descriptionKey: 'qualityScore.rd3c.complianceDescription',
  },
  {
    titleKey: 'qualityScore.rd3c.relevanceTitle',
    descriptionKey: 'qualityScore.rd3c.relevanceDescription',
  },
  {
    titleKey: 'qualityScore.rd3c.differentiationTitle',
    descriptionKey: 'qualityScore.rd3c.differentiationDescription',
  },
];
